<template>
    <div>
        <ul class="catalog">
            <li @click="changeTab(item.path)" :class="{active:item.path==$route.path}" v-for="(item,index) in classify">{{item.name}}</li>
        </ul>

        <div class="container wrap">
            <ul class="artical">
                <li v-for="(item,index) in $store.state.travelArtical" v-show="pageshow(index)" @click="readArtical(item.id)">
                    <div class="time">
                        <p class="month">{{item.month}}</p>
                        <p class="day">{{item.day}}</p>
                    </div>
                    <div class="content">
                        <div class="picture">
                            <img :src="item.img" />
                        </div>
                        <div class="words">
                            <p class="title">{{item.title}}</p>
                            <p class="desc">{{item.desc}}</p>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <paginate class="paginate" :page-count="page.count" :page-range="page.range" :page-class="'pageli'" :active-class="'pageActive'" :disabled-class="'pageDisable'" :first-last-button="true" :next-class="'pageli'" :prev-class="'pageli'" :next-text="'>'" :prev-text="'<'" :first-button-text="'<<'" :last-button-text="'>>'" :click-handler="pagechoose">
        </paginate>
    </div>
</template>

<script>
export default {
    data() {
        return {
            page: {
                count: 1,
                range: 8,
                num: 1,
            },
        }
    },

    props: ['classify'],

    mounted(){
        window.scrollTo(0,0);
    },

    methods: {
        pagechoose(pageNum) {
            // console.log(pageNum);
            $(window).scrollTop(0);
            this.page.num = pageNum;
        },
        readArtical(index){
            this.$store.commit('changetravelArticalId',index);
            this.$router.push({path: '/travelContent'});
        },
        changeTab(path){
            this.$router.replace(path)
        }
    },

    computed: {
        pageshow(index) {
            return function (index) {
                let num = this.page.num * 8;
                return (index >= num - 8) && (index < num);
            }
        },
    },

    components: {
    },
}

</script>

<style scoped lang='less'>
@import "./../../assets/css/artical.less";
</style>


// WEBPACK FOOTER //
// src/views/artical/travelList.vue